/**
 * THE SHOT TABLE — the bottom-right stack, which carries the FIGURES the advice band refuses (§91).
 *
 * One word per cell, and that is a constraint and not a style: these are table headings over a number
 * read at a glance mid-match, so they may not borrow the panel's prose. The same magnitudes are named at
 * length in `loadout` — the panel is where a setup is decided, this is where it is checked.
 */
// PROD-CLEANUP: nothing calls t('readout.*') — the panel in combatReadout.ts labels itself. Either wire
// it to this namespace or drop the namespace; today it is five strings no lookup can reach.
export default {
  fps: 'FPS',
  weight: 'BB',
  hop: 'HOP-UP',
  // The two distances that decide whether an impact pays: below the first it does not score, past the
  // second it arrives without the energy to be felt.
  min: 'MINIMUM',
  max: 'MAXIMUM',
};
